import moment from 'moment/moment';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import * as AppConst from '../../../constants/App';
import {showAuthModal} from '../../../actions/User';
import CustomDatepickerInput from '../../Base/CustomDatepickerInput';
import {booking, bookingCalculate} from '../../../actions/ObjectPage';
import {getCalculationResult, prepareCalculationMessage} from "./CalculationUtils";
import {loadStripe} from "@stripe/stripe-js";

let stripe = undefined

const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
};

const defaultProps = {
    showAuthModal: isShowAuthModal => {
    },
    bookingCalculate: (objectId, rentCalculationCommand) => {
    }
};

class BookingModal extends Component {
    state = {
        reservationErrorMessage: '',
        isShowSelectGuestsOptions: false,

        dateStart: undefined,
        dateEnd: undefined,
        countGuests: 0,
    };

    getExcludeDates = () => {
        const {days} = this.props;
        let excludeDates = [];

        days.forEach(day => {
            if (day.blocked) {
                excludeDates.push(moment(day.date, AppConst.CALENDAR_DATE_FORMAT))
            }
        });
        return excludeDates;
    };

    toggleSelectGuestsOptions = () => {
        this.setState(prevState => ({
            isShowSelectGuestsOptions: !prevState.isShowSelectGuestsOptions
        }))
    };

    handleReservationClick = event => {
        event.preventDefault();
        const {
            i18n,
            userId,
            objectId,
            closeModal,
            accessToken,
            showAuthModal
        } = this.props;

        let {dateStart, dateEnd, countGuests} = this.state;

        if (accessToken === null) {
            closeModal();
            showAuthModal(true);

            return;
        }

        let reservationErrorMessage = '';
        if (countGuests === 0) {
            reservationErrorMessage = i18n['objectPage.countGuestsErrorMessage'];
        } else if (dateStart === undefined) {
            reservationErrorMessage = i18n['objectPage.selectTheArrivalDate'];
        } else if (dateEnd === undefined) {
            reservationErrorMessage = i18n['objectPage.selectDepartureDate'];
        } else {
            let request = {
                countGuests: countGuests,
                dateStart: dateStart.format(AppConst.DATE_FORMAT),
                dateEnd: dateEnd.format(AppConst.DATE_FORMAT)
            };

            this.props.booking(objectId, request).then(sessionId=>{
                stripe.redirectToCheckout({
                    sessionId: sessionId
                })
            });
        }

        this.setState({
            reservationErrorMessage: reservationErrorMessage
        })
    };

    getCalculationResult = () => {
        const {isShowCalculationResult} = this.props;

        if (isShowCalculationResult) {
            return getCalculationResult(this.state.dateStart, this.state.dateEnd, this.props.calculationResult, this.props.i18n);
        }
    };

    handleDateStartChange = date => {
        if (date.isBefore(moment().subtract(1, 'days'))) {
            return;
        }
        let {dateStart, dateEnd} = this.state;

        if (dateEnd === undefined || date.isSameOrBefore(dateEnd)) {
            this.setState({dateStart: date}, () => {
                this.bookingCalculate();
            });

            if (dateEnd !== undefined) {
                this.setState({
                    isShowHint: false
                });
            }
        }

    };

    handleDateEndChange = date => {
        if (date.isBefore(moment().subtract(1, 'days'))) {
            return;
        }
        let {dateStart, dateEnd} = this.state;

        if (dateStart === undefined || date.isSameOrAfter(dateStart)) {
            this.setState({
                dateEnd: date
            }, () => {
                this.bookingCalculate();
            });

            if (dateStart !== undefined) {
                this.setState({
                    isShowHint: false
                });
            }
        }
    };

    handleCountGuestsChange = e => {
        let newValue = parseInt(e.target.value, 10);
        this.setState({countGuests: newValue}, this.bookingCalculate);
    };

    bookingCalculate = () => {
        const {bookingCalculate, objectId} = this.props;
        let {dateStart, dateEnd, countGuests} = this.state;

        if (dateStart === undefined
            || dateEnd === undefined
            || countGuests === undefined
            || countGuests == 0
        ) {
            return;
        }

        let request = {
            countGuests: countGuests,
            dateStart: dateStart.format(AppConst.DATE_FORMAT),
            dateEnd: dateEnd.format(AppConst.DATE_FORMAT)
        };

        bookingCalculate(objectId, request);
    };

    getGuestOptions = () => {
        let countGuest = this.props.currentObject.props.countGuest;

        let values = [];
        for (let i = 1; i <= countGuest; i++) {
            if (i < 16) {
                values.push(<li key={i} value={i} onClick={this.handleCountGuestsChange}>{i}</li>);
            } else if (i === 16) {
                values.push(<li key={i} value={i} onClick={this.handleCountGuestsChange}>{i}+</li>);
            }
        }

        return (
            <ul>
                {values.map(elem => elem)}
            </ul>
        );
    };

    isReserveActive() {
        let {errorMessage} = this.props;
        let {dateStart, dateEnd, countGuests} = this.state;

        if (dateStart === undefined
            || dateEnd === undefined
            || countGuests === undefined
            || countGuests == 0
        ) {
            return false;
        }

        if (errorMessage != undefined && errorMessage != null) {
            return false
        }

        return true;
    }

    render() {
        const {
            i18n,
            code,
            isOpen,
            closeModal,
            errorMessage,
            isShowCalendarLoading
        } = this.props;

        const {isShowHint, reservationErrorMessage, dateStart, dateEnd, countGuests} = this.state;

        if (stripe === undefined && this.props.stripePublicKey !== undefined) {
            loadStripe(this.props.stripePublicKey).then(r=>{
                stripe = r
            })
        }

        return (
            <ReactModal
                isOpen={isOpen}
                className="popup booking-modal"
                overlayClassName="popup-overlay"
            >
                <div onClick={closeModal} className="popup-close"/>

                <div className="sidebar-dates">
                    <div className="flex">
                        <div className="to-date">
                            {code !== undefined && <DatePicker
                                locale={code}
                                selected={dateStart}
                                openToDate={dateStart === undefined ? dateEnd : undefined}
                                disabled={isShowCalendarLoading}
                                dateFormat={AppConst.DATE_FORMAT}
                                onChange={this.handleDateStartChange}
                                excludeDates={this.getExcludeDates()}
                                popperClassName="book-it-sidebar_datepicker"
                                dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                    'react-datepicker__day--disabled' :
                                    date.isSame(dateStart) ?
                                        'selecting-range-start' :
                                        undefined}
                                customInput={
                                    <CustomDatepickerInput
                                        customClassName="text-field"
                                        placeholderText={i18n['objectPage.dateStartPlaceholder']}
                                    />
                                }
                            />}
                        </div>
                        <div className="from-date">
                            {code !== undefined && <DatePicker
                                locale={code}
                                selected={dateEnd}
                                openToDate={dateEnd === undefined ? dateStart : undefined}
                                disabled={isShowCalendarLoading}
                                dateFormat={AppConst.DATE_FORMAT}
                                onChange={this.handleDateEndChange}
                                excludeDates={this.getExcludeDates()}
                                popperClassName="book-it-sidebar_datepicker date-end"
                                dayClassName={date => date.isBefore(moment().subtract(1, 'days')) ?
                                    'react-datepicker__day--disabled' :
                                    date.isSame(dateEnd) ?
                                        'selecting-range-start' :
                                        undefined}
                                customInput={
                                    <CustomDatepickerInput
                                        customClassName="text-field"
                                        placeholderText={i18n['objectPage.dateEndPlaceholder']}
                                    />
                                }
                            />}
                        </div>
                        <div className="sd_select-guests" onClick={this.toggleSelectGuestsOptions}>
                            <span>
                                {countGuests !== 0 ? countGuests : i18n['objectPage.guests']}
                            </span>
                            {this.state.isShowSelectGuestsOptions && this.getGuestOptions()}
                        </div>
                    </div>

                    {isShowHint && <div>
                        <br/><br/>
                        {i18n['objectPage.hint']}
                    </div>}

                    {reservationErrorMessage.length > 0 && <div>
                        <br/><br/>
                        {prepareCalculationMessage(reservationErrorMessage, i18n)}
                    </div>}

                    {errorMessage !== undefined && errorMessage !== null && <div>
                        <br/><br/>
                        {prepareCalculationMessage(errorMessage, i18n)}
                    </div>}

                    {this.getCalculationResult()}

                    <button
                        type="submit"
                        className="btn"
                        onClick={this.handleReservationClick}
                        disabled={!this.isReserveActive()}
                    >
                        {i18n['objectPage.reservation']}
                    </button>
                </div>
            </ReactModal>
        )
    }
}

BookingModal.propTypes = propTypes;
BookingModal.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    userId: state.user.currentUser.id,
    days: state.objectPage.calendars.days,
    code: state.languages.currentLanguage.code,
    objectId: state.objectPage.currentObject.id,
    currentObject: state.objectPage.currentObject,
    accessToken: state.user.currentUser.accessToken,
    isNeedCalculate: state.objectPage.isNeedCalculate,
    calculationResult: state.objectPage.calculationResult,
    isShowCalendarLoading: state.objectPage.isShowCalendarLoading,
    errorMessage: state.objectPage.calculationResult.errorMessage,
    isShowCalculationResult: state.objectPage.isShowCalculationResult,
    stripePublicKey: state.configuration.stripePublicKey
});

const mapDispatchToProps = {
    showAuthModal,
    bookingCalculate,
    booking
};

export default connect(mapStateToProps, mapDispatchToProps)(BookingModal);



// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/BookingModal.js